import React from 'react'
import WidgetIcon from '../../../Atoms/WidgetIcon/WidgetIcon'
import { ReactComponent as Icon } from './MatrixChartWidget.Icon.svg'

export default () => <WidgetIcon icon={Icon} />
